import { render, staticRenderFns } from "./MainVisual.vue?vue&type=template&id=05f7978a"
import script from "./MainVisual.vue?vue&type=script&lang=js"
export * from "./MainVisual.vue?vue&type=script&lang=js"
import style0 from "./MainVisual.vue?vue&type=style&index=0&id=05f7978a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports